import * as Yup from "yup";

export const supportingDocsValidations = (section, formType, dbFormSpec, languageText) => {
    if (section.active) {
        let minFileCount = dbFormSpec.idVerification ? parseInt(dbFormSpec.idVerification.numOfDocsExpected || 0): 0;
        let filesMessage = languageText.ErrorChecking.ValidatorText.fileLimitCount + minFileCount;

        return Yup.object().shape({
            supportingDoc: (dbFormSpec.idVerification && minFileCount > 0) && Yup.array()
                .required(
                    () => `${languageText.ErrorChecking.ValidatorText.PleaseUpload}`
                )
                .test(
                    'file-limit',
                    languageText.ErrorChecking.ValidatorText.fileLimit,
                    function checkIfFilesAreCorrectType(files) {

                        if (files) {
                            return files.length <= 4;
                        }
                        return true;
                    }
                )
                .test(
                    'file-minimum',
                    filesMessage,
                    function checkIfFilesAreCorrectType(files) {

                        if (files && files.length >= minFileCount) {
                            return true;
                        }
                        return false;
                    }
                )
                .test(
                    'is-file-big',
                    `${languageText.ErrorChecking.ValidatorText.IsFileBig}`,
                    function checkIfFilesAreCorrectSize(files) {
                        let valid = true
                        if (files) {
                            files.map(file => {
                                if (file.size > 1.5e+7) {
                                    valid = false
                                }
                            })
                        }
                        return valid
                    }
                )
        });
    } else {
        return Yup.object().shape();
    }
};


export const supportingDocsValidationsProxy = (section, formType, dbFormSpec, languageText) => {
    if (formType === "Representative") {
        let minFileCountProxy = dbFormSpec.idVerificationProxy ? parseInt(dbFormSpec.idVerificationProxy.numOfDocsExpected || 0): 0;
        let filesMessageProxy = languageText.ErrorChecking.ValidatorText.fileLimitCount + minFileCountProxy;

        return Yup.object().shape({
            supportingDocProxy: (dbFormSpec.idVerificationProxy && minFileCountProxy > 0) && Yup.array()
                .required(
                    () =>
                        `${languageText.ErrorChecking.ValidatorText.PleaseAlsoUpload}`
                )
                .test(
                    'file-limit',
                    languageText.ErrorChecking.ValidatorText.fileLimit,
                    function checkIfFilesAreCorrectType(files) {

                        if (files) {
                            return files.length <= 4;
                        }
                        return true;
                    }
                )
                .test(
                    'file-minimum',
                    filesMessageProxy,
                    function checkIfFilesAreCorrectType(files) {
                        if (files && files.length >= minFileCountProxy) {
                            return true;
                        }
                        return false;
                    }
                )
                .test(
                    'is-file-big',
                    `${languageText.ErrorChecking.ValidatorText.IsFileBig}`,
                    function checkIfFilesAreCorrectSize(files) {
                        let valid = true
                        if (files) {
                            files.map(file => {
                                if (file.size > 1.5e+7) {
                                    valid = false
                                }
                            })
                        }
                        return valid
                    }
                ),
            documentationProxy: Yup.string()
                .required(
                    () =>
                        `${languageText.ErrorChecking.ValidatorText.PleaseSelect}`
                )
        });
    } else { return Yup.object().shape(); }
};